import { Heading } from '@ksyos/design-system';
import { Paragraph } from '../../../../elements/atoms/paragraph/Paragraph';
import { IntroContainer } from '../../../../elements/molecules/introContainer/IntroContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';

export function ProcedureSentMessage() {
    return (
        <IntroContainer style={{ textAlign: 'center' }}>
            <Stack>
                <img
                    alt="Success"
                    src="/assets/images/derma-oth/alto-success.svg"
                    style={{ maxWidth: '60%' }}
                />
            </Stack>
            <Stack>
                <Heading size="xlarge">Je antwoorden zijn verzonden</Heading>
            </Stack>
            <Stack>
                <Paragraph>
                    Je huisarts gaat de antwoorden bekijken. De huisarts zal je bellen om de situatie te bespreken. Houd
                    daarom je telefoon bij de hand.
                </Paragraph>
            </Stack>
        </IntroContainer>
    );
}
